import React from 'react';
import { Route, Routes } from 'react-router-dom';
import BillsIndex from './pages/BillsIndex';

const BillsRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<BillsIndex />} />
      {/* Alte rute pot fi adăugate aici în viitor */}
      {/* <Route path="/create" element={<BillCreate />} /> */}
      {/* <Route path="/:id/edit" element={<BillEdit />} /> */}
    </Routes>
  );
};

export default BillsRoutes;